export const getuuid = (length, range) => {
  let leng = 12;
  let ran = 36;
  if (length && length > 0) {
    leng = length;
  }
  if (range && range > 0 && range <= 62) {
    ran = range;
  }
  const chars = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"
  ];
  const resultArr = [];
  for (let i = 0; i < leng; i++) {
    const index = Math.floor(Math.random() * ran);
    resultArr.push(chars[index]);
  }
  return resultArr.join("");
};
